<template>
  <div class="menu-bar">
    <template v-if="loggedIn">
      <MenuLink to="/library" icon="menu_bibliothek" title="Bibliothek" />
      <MenuLink to="/generator" icon="menu_generator" title="Generator" />
      <MenuLink to="/screens" icon="menu_screens" title="Bildschirme" />
      <!--<MenuLink to="/apps" icon="menu_apps" title="Anwendungen" />-->
      <MenuLink to="/playlists" icon="menu_playlists" title="Playlists" />
      <MenuLink to="/releaseRequests" icon="menu_settings" title="Redaktion" v-if="isEditor" />
      <MenuLink to="/users" icon="menu_users" title="Benutzer" v-if="isAtLeastAdmin" />
      <MenuLink to="/settings" icon="menu_settings" title="Einstellungen" v-if="isSuperAdmin" />
    </template>
  </div>
</template>

<script>
import MenuLink from "@/components/elements/MenuLink.vue";

export default {
  data() {
    return {};
  },
  components: {
    MenuLink,
  },
  computed: {
    isSuperAdmin() {
      return this.$store.state.user?.role === 'super_admin';
    },
    isAtLeastAdmin() {
      const r = this.$store.state.user?.role;
      return r === 'admin' || r === 'super_admin';
    },
    isEditor() {
      const user = this.$store.state.user;
      if(!user) {
        return false;
      }
      if(user.role === 'admin' || user.role === 'super_admin') {
        return true;
      }
      return Object.values(user.groupsFull || {}).some(item => item.isAdmin);
    }
  },
  props: [
    "loggedIn",
  ]
}
</script>